import { ExistingPatientBookingResponse, GapFillerResponse, NewPatientBookingResponse } from '@customTypes/Booking'
import { AfterBookingState } from '@context/ConfigurationContext'

export const getAfterBookingStateFromBookingResponse = (
  data?: ExistingPatientBookingResponse | GapFillerResponse | NewPatientBookingResponse
): AfterBookingState => {
  if (!data) return { hasHealthAssistant: false, hasValidAnamnesis: false, linkToAna: '', healthAssistantLink: '' }

  const linkToAna: string = data.anamnesisLink || ''
  const healthAssistantLink: string = data.healthAssistantLink || ''
  const hasHealthAssistant: boolean = data.hasHealthAssistant || false
  const hasValidAnamnesis: boolean = data.hasValidAnamnesis || false

  return {
    linkToAna,
    healthAssistantLink,
    hasHealthAssistant,
    hasValidAnamnesis,
  }
}
